// extracted by mini-css-extract-plugin
export default {"wrapper":"contact_wrapper__ORH+6","container":"contact_container__fTGru","header":"contact_header__J16pW","descr":"contact_descr__dBF09"};